import './queries/read';

import { createCollection } from 'lib/resource';
import store from 'app/store';
import Episode from 'resources/episode/schema';
import { runOperation } from 'app/operations';
import ShowDrafts from './schema';

const controller = {
  getState: () => store.get().getState(),
  runOperation,
};

export default createCollection(ShowDrafts, Episode, controller);
